import React from "react";

export const HeaderText = ({ text, extraText }) => {
  return (
    <div>
      <h1 className="items__title saara-title">
        {text}&nbsp;<span>{extraText}</span>
      </h1>
    </div>
  );
};
